import { render, staticRenderFns } from "./index.vue?vue&type=template&id=232ad18a&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('232ad18a')) {
      api.createRecord('232ad18a', component.options)
    } else {
      api.reload('232ad18a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=232ad18a&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&", function () {
      api.rerender('232ad18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/referral_programs/logs/index.vue"
export default component.exports